import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import { ext } from "@/lib/ext";

const Login = () => {
  const { login, user, ready } = useAuth();
  const { lang } = useLang();
  const e = ext[lang];
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (ready && user) navigate(user.role === "admin" ? "/admin" : "/account");
  }, [ready, user, navigate]);

  const submit = async (ev) => {
    ev.preventDefault();
    setErr(""); setLoading(true);
    try {
      const u = await login(email, password);
      navigate(u.role === "admin" ? "/admin" : "/account");
    } catch (e2) {
      const d = e2.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Autentificare eșuată");
      setLoading(false);
    }
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-white px-4" data-testid="login-page">
      <form onSubmit={submit} className="w-full max-w-sm border border-border p-8">
        <Link to="/" className="mb-8 flex justify-center"><img src="/logo.png" alt="LAINER" className="h-6 w-auto" /></Link>
        <div className="mb-6 font-mono text-[11px] uppercase tracking-widest text-muted-foreground">{e.login}</div>
        <label className="mb-1 block font-mono text-[10px] uppercase tracking-widest text-muted-foreground">{e.email}</label>
        <input data-testid="login-email" type="email" value={email} onChange={(ev) => setEmail(ev.target.value)} required
          className="mb-4 w-full border border-border px-3 py-3 font-mono text-sm focus:outline-none focus:ring-1 focus:ring-foreground" />
        <label className="mb-1 block font-mono text-[10px] uppercase tracking-widest text-muted-foreground">{e.password}</label>
        <input data-testid="login-password" type="password" value={password} onChange={(ev) => setPassword(ev.target.value)} required
          className="mb-6 w-full border border-border px-3 py-3 font-mono text-sm focus:outline-none focus:ring-1 focus:ring-foreground" />
        {err && <div data-testid="login-error" className="mb-4 font-mono text-[11px] uppercase tracking-widest text-destructive">{err}</div>}
        <button data-testid="login-submit" disabled={loading} type="submit"
          className="w-full bg-foreground py-4 text-sm uc font-medium text-white transition-opacity hover:opacity-85 disabled:opacity-50">
          {loading ? "..." : e.login}
        </button>
        <div className="mt-4 text-center font-mono text-[11px] uppercase tracking-widest text-muted-foreground">
          {e.noAccount} <Link to="/register" className="underline underline-offset-4 hover:text-foreground">{e.register}</Link>
        </div>
      </form>
    </main>
  );
};

export default Login;
